import PropTypes from 'prop-types';
import React from 'react';

import InfiniteTable from '../../common/InfiniteTable';
import style from './style';
import PostCell from '../Feed/PostsTable/PostCell/PostCell.Container';
import SchedulePostDialog from '../Feed/SchedulePostDialog';
import PostNavigation from '../Feed/PostNavigation/PostNavigation.container';

const PAGE_TITLE = 'Scheduled posts';

class SchedulePostList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleLoadNext = this.handleLoadNext.bind(this);
  }

  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentWillReceiveProps(nextProps) {
    const { scheduledPosts, fetch } = this.props;
    if (
      scheduledPosts.length === 0 &&
      nextProps.scheduledPosts.length === 0 &&
      nextProps.spaceId &&
      !nextProps.isFetching &&
      nextProps.count > 0
    ) {
      fetch(nextProps.spaceId);
    }
  }

  componentDidUpdate() {
    this.updateDocumentTitle();
  }

  updateDocumentTitle() {
    const { currentSpaceName } = this.props;
    const space = currentSpaceName ? `${currentSpaceName} - ` : '';
    document.title = `${PAGE_TITLE} - ${space}Aula`;
  }

  handleLoadNext() {
    const { spaceId, fetch } = this.props;
    return fetch(spaceId);
  }

  render() {
    const { scheduledPosts, count, isFetching, hasFetchedAll } = this.props;

    return (
      <div style={style.parentContainer}>
        <InfiniteTable
          items={scheduledPosts}
          renderItem={(post) => (
            <div style={style.postWrapper}>
              <PostCell post={post} style={style.postCell} />
            </div>
          )}
          keyExtractor={(post) => post.objectId}
          hasNext={!hasFetchedAll}
          loadNext={this.handleLoadNext}
          loading={isFetching}
          renderHeader={() => (
            <div style={style.header}>
              <PostNavigation style={style.navigation} />
              <span style={style.title}>{`${PAGE_TITLE} (${count})`}</span>
              <SchedulePostDialog />
            </div>
          )}
          viewStyle={style.postsContainer}
          contentStyle={style.table}
        />
      </div>
    );
  }
}

SchedulePostList.propTypes = {
  count: PropTypes.number,
  fetch: PropTypes.func.isRequired,
  spaceId: PropTypes.string,
  currentSpaceName: PropTypes.string,
  scheduledPosts: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool.isRequired,
  hasFetchedAll: PropTypes.bool.isRequired,
};

SchedulePostList.defaultProps = {
  spaceId: null,
  currentSpaceName: '',
  count: 0,
};

export default SchedulePostList;
